export const number = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить номер <b>{number}<b>?`,
      disabled: 'Нельзя удалить номер, использующийся в точке входа или в SIP-аккаунте'
    },

    create_internal: {
      input: {
        number: {
          title: 'Номер телефона'
        }
      }
    }
  },

  list: {
    button: {
      create_internal: 'Добавить внутренний номер'
    }
  },

  field: {
    number: 'Номер',
    type: 'Тип номера',
    type_use: 'Тип использования',
    login: 'Логин'
  },

  type: {
    internal: 'Внутренний | Внутренние',
    external: 'Внешний | Внешние'
  },

  type_use: {
    use: 'Используется',
    not_use: 'Не используется'
  }
};
